import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

// Sesja panelu admina dzieli localStorage z konfiguratorem - start nowej konfiguracji nie może jej usuwać
const ADMIN_SESSION_KEYS = ["adminToken", "adminPermissions", "adminLang"];

const HomePage = () => {
  // Wejście na "/" (np. z linku w sklepie) zaczyna nową konfigurację
  useEffect(() => {
    const preserved = ADMIN_SESSION_KEYS.map((key) => [key, localStorage.getItem(key)] as const);
    localStorage.clear();
    preserved.forEach(([key, value]) => {
      if (value !== null) localStorage.setItem(key, value);
    });
  }, []);

  return <Navigate to="/1" replace/>;
};

export default HomePage;
